import { render, staticRenderFns } from "./create_org_form.vue?vue&type=template&id=75b7345c"
import script from "./create_org_form.vue?vue&type=script&lang=js"
export * from "./create_org_form.vue?vue&type=script&lang=js"
import style0 from "./create_org_form.vue?vue&type=style&index=0&id=75b7345c&prod&lang=css"
import style1 from "./create_org_form.vue?vue&type=style&index=1&id=75b7345c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports